// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dynamic-forms {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 2em;
}

.dynamic-forms_container {
  width: 50%;
}

.dynamic-forms_stepper {
  width: 100%;
}

.dynamic-forms_stepper-button {
  background: transparent;
  border: none;
  color: var(--primary-color);
}
`, "",{"version":3,"sources":["webpack://./src/Calendar/assets/scheduler/css/view/dynamicForm.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,2BAA2B;AAC7B","sourcesContent":[".dynamic-forms {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  margin-top: 2em;\n}\n\n.dynamic-forms_container {\n  width: 50%;\n}\n\n.dynamic-forms_stepper {\n  width: 100%;\n}\n\n.dynamic-forms_stepper-button {\n  background: transparent;\n  border: none;\n  color: var(--primary-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
